var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuarterAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6.47715 6.47715 2 12 2V4.25C12.4142 4.25 12.75 4.58579 12.75 5V6C12.75 6.41421 12.4142 6.75 12 6.75V12H6.75C6.75 12.4142 6.41421 12.75 6 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12H2ZM8.28765 8.28765C8.58055 7.99476 8.58055 7.51989 8.28765 7.22699L7.58055 6.51989C7.28765 6.22699 6.81278 6.22699 6.51989 6.51989C6.22699 6.81278 6.22699 7.28765 6.51989 7.58055L7.22699 8.28765C7.51989 8.58055 7.99476 8.58055 8.28765 8.28765Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18C11.25 17.5858 11.5858 17.25 12 17.25C12.4142 17.25 12.75 17.5858 12.75 18V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7498 12C19.7498 11.5858 19.414 11.25 18.9998 11.25H17.9998C17.5855 11.25 17.2498 11.5858 17.2498 12C17.2498 12.4142 17.5855 12.75 17.9998 12.75H18.9998C19.414 12.75 19.7498 12.4142 19.7498 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.48 6.51996C17.1871 6.22707 16.7123 6.22707 16.4194 6.51996L15.7123 7.22707C15.4194 7.51996 15.4194 7.99484 15.7123 8.28773C16.0052 8.58062 16.48 8.58062 16.7729 8.28773L17.48 7.58062C17.7729 7.28773 17.7729 6.81286 17.48 6.51996Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22701 15.7123C7.51991 15.4195 7.99478 15.4195 8.28767 15.7123C8.58057 16.0052 8.58057 16.4801 8.28767 16.773L7.58057 17.4801C7.28767 17.773 6.8128 17.773 6.51991 17.4801C6.22701 17.1872 6.22701 16.7123 6.51991 16.4195L7.22701 15.7123Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4798 17.48C17.7727 17.1871 17.7727 16.7123 17.4798 16.4194L16.7727 15.7123C16.4798 15.4194 16.0049 15.4194 15.712 15.7123C15.4191 16.0052 15.4191 16.48 15.712 16.7729L16.4191 17.48C16.712 17.7729 17.1869 17.7729 17.4798 17.48Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarterAlt1);
export default __webpack_public_path__ + "static/media/quarter-alt-1.ad1b38c4b97318c6e00dcb2576aa6851.svg";
export { ForwardRef as ReactComponent };